module.exports = __webpack_public_path__ + "img/introduce2.9d17a59e.png";